var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 0V8.7075C18.6013 9.1743 19.5078 10.4466 19.5078 11.8763C19.5078 13.3059 18.6013 14.5782 17.25 15.045V23.76L9.435 19.5675L5.565 23.4375L3.4425 21.315L6.6675 18.09L5.5725 17.505H0V6.255H5.5725L17.25 0ZM3 9.255V14.505H6V9.255H3ZM14.25 18.75L7.5 15.135V8.625L14.25 5.01V18.75ZM22.0147 6.05109L19.7183 8.34742L20.779 9.40808L23.0753 7.11175L22.0147 6.05109ZM20.7738 14.3371L19.7348 15.419L22.0285 17.6216L23.0675 16.5397L20.7738 14.3371ZM21 11.13H24V12.63H21V11.13Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/SpeakerIcon.fa6c94f6fe1c8b91aea958effb55d530.svg";
export { ForwardRef as ReactComponent };